import { getUrlRoot } from "../services/network";

export const redirectTo = (redirectUrl: string) => {
  const root = getUrlRoot();
  const fullUrl = root + redirectUrl;
  window.location.href = fullUrl;
};
